export default __webpack_public_path__ + "static/logo-5b8e49236a76677a71c9ef5f84661129.png";